import { render, staticRenderFns } from "./holidaysCalendar.vue?vue&type=template&id=172beaee&"
import script from "./holidaysCalendar.vue?vue&type=script&lang=js&"
export * from "./holidaysCalendar.vue?vue&type=script&lang=js&"
import style0 from "./holidaysCalendar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports